import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "mh-profile-section-header",
  templateUrl: "./profile-section-header.component.html",
  styleUrls: ["./profile-section-header.component.less"],
})
export class ProfileSectionHeaderComponent {
  @Input() iconType!: string;
  @Input() titleText!: string;
  @Input() isCollapsed = false;
  @Input() sectionId!: string;
  @Output() toggle = new EventEmitter<string>();

  onToggle(): void {
    this.toggle.emit(this.sectionId);
  }
}
